export default __webpack_public_path__ + "_/images/knowledge-center/category-deposits-5c56f2df9efbc401b03726562aa53334e34717e12e41b706ab796b99fa9b410e.png";